/* eslint-disable */
import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { ClientContext } from "ClientProvider";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
// chakra imports

export const SidebarLinks = (props: { routes: RoutesType[] }): JSX.Element => {
  const { singleRoleData } = useContext(ClientContext);
  const { setActiveTab } = useContext(ClientContext);
  
  // Chakra color mode
  let location = useLocation();
  const navigate = useNavigate();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routePath: string) => {
    const currentPath = location.pathname.replace("/admin","");
    return currentPath === routePath || currentPath === `/${routePath}`;
  };

  const routeHiden = (route: any) => {

    let isStatus = false;

    if (
      route?.path ===
      singleRoleData?.[0]?.payment_method?.name?.replace(" ", "")
    ) {
      isStatus =
        singleRoleData?.[0]?.payment_method?.value?.view_payment_method_list;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.payment_method?.value?.view_payment_method_list
      ) {
        navigate("/admin/dashboard");
      }
    }
    if (
      route?.path === singleRoleData?.[0]?.subscription?.name?.replace(" ", "")

    ) {
      isStatus = singleRoleData?.[0]?.subscription?.value?.view_subscription_list;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.subscription?.value?.view_subscription_list
      ) {
        navigate("/admin/dashboard");

      }

    }
    if (
      route?.path ===
      singleRoleData?.[0]?.client?.name?.replace(" ", "") + "s"
    ) {
      isStatus = singleRoleData?.[0]?.client?.value?.view_client_list;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.client?.value?.view_client_list
      ) {
        navigate("/admin/dashboard");
      }
    }

    if (
      route?.path ===
      singleRoleData?.[0]?.customers?.name?.replace(" ", "")
    ) {
      isStatus = singleRoleData?.[0]?.customers?.value?.view_customers;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.customers?.value?.view_customers
      ) {
        navigate("/admin/dashboard");
      }
    }

    
    if (
      route?.path ===
      singleRoleData?.[0]?.settlement?.name?.replace(" ", "")
    ) {
      isStatus = singleRoleData?.[0]?.settlement?.value?.view_settlement_list;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.settlement?.value?.view_settlement_list
      ) {
        navigate("/admin/dashboard");
      }
    }

    if (
      route?.path ===
      singleRoleData?.[0]?.organization?.name?.replace(" ", "") + "s"
    ) {
      isStatus =
        singleRoleData?.[0]?.organization?.value?.view_organization_list;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.organization?.value?.view_organization_list
      ) {
        navigate("/admin/dashboard");
      }
    }

   
    if (
      route?.path ===
      singleRoleData?.[0]?.payment?.name?.replace(" ", "") + "s"
    ) {
      isStatus = singleRoleData?.[0]?.payment?.value?.view_payment_list;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.payment?.value?.view_payment_list
      ) {
        navigate("/admin/dashboard");
      }
    }
    if (
      route?.path == singleRoleData?.[0]?.token?.name?.replace(" ", "") + "s"

    ) {
      isStatus = singleRoleData?.[0]?.token?.value?.view_token_list;;
      if (
        location?.pathname === route?.layout + "/" + route?.path &&
        !singleRoleData?.[0]?.token?.value?.view_token_list
      ) {
        navigate("/admin/dashboard");
      }
    }
    // if (
    //   route?.path == singleRoleData?.[0]?.payout?.name?.replace(" ", "")

    // ) {
    //   isStatus = singleRoleData?.[0]?.payout?.value?.view_payout_list;
    //   if (
    //     location?.pathname === route?.layout + "/" + route?.path &&
    //     !singleRoleData?.[0]?.payout?.value?.view_payout_list
    //   ) {
    //     navigate("/admin/dashboard");
    //   }
    // }

    if (route?.path=== 'payout') {
      const hasAnyPlatformPermission =
        singleRoleData?.[0]?.payout?.value?.view_payout_list ||
        singleRoleData?.[0]?.payout?.value?.view_batch_payout;
      isStatus = hasAnyPlatformPermission;
    }

    if (route?.path=== 'fiat-payout') {
      const hasAnyPlatformPermission =
        singleRoleData?.[0]?.fiat?.value?.view_fiat_payout_list || singleRoleData?.[0]?.fiat?.value?.view_single_fiat_payout_list;
      isStatus = hasAnyPlatformPermission;
    }
  
    if (route?.name === "Dashboard") {
      isStatus = true;
    }

    if (route?.name=== 'Platform Management') {
      const hasAnyPlatformPermission =
        singleRoleData?.[0]?.user?.value?.view_user_list ||
        singleRoleData?.[0]?.user?.value?.view_self_created_user ||
        singleRoleData?.[0]?.role?.value?.view_role_list ||
        singleRoleData?.[0]?.api_request_logs?.value?.view_api_request_logs ||
        singleRoleData?.[0]?.audit_logs?.value?.view_user_audit_logs ||
        singleRoleData?.[0]?.blacklist?.value?.view_blacklist_list ||
        singleRoleData?.[0]?.kyc_velocity?.value?.view_kyc_velocity ||
        singleRoleData?.[0]?.settings?.value?.view_settings ||
        singleRoleData?.[0]?.api?.value?.view_api_list;
      
        
      isStatus = hasAnyPlatformPermission;
    }

    if (route?.name=== 'Crypto') {
      const hasAnyPlatformPermission =
        singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_list || singleRoleData?.[0]?.crypto?.value?.view_single_crypto_payout_list  || singleRoleData?.[0]?.crypto?.value?.view_crypto_payin ;
      isStatus = hasAnyPlatformPermission;
    }

    return isStatus;
  };
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const createLinks = (routes: RoutesType[]) => {

    // const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
    // const toggleMenu = (menuName: string) => {
    //   setOpenMenus((prev) => ({
    //     ...prev,
    //     [menuName]: !prev[menuName],
    //   }));
    // };
    const toggleMenu = (menuName: string) => {
      setOpenMenus((prev) => {
        const isCurrentlyOpen = prev[menuName];
        return isCurrentlyOpen
          ? {}
          : { [menuName]: true };
      });
    };

    return routes.map((route, index) => {
      if (route.layout === "/admin" && routeHiden(route)) {
        // const isOpen = openMenus[route.name] ?? route.children?.some((child) =>
        //   location.pathname.includes(`${child.layout}/${child.path}`)
        // );

        const isOpen = !!openMenus[route.name];

        const hasChildPermission = (child: RoutesType) => {
          switch (child.name) {
            case 'Users':
              return (
                singleRoleData?.[0]?.user?.value?.view_user_list ||
                singleRoleData?.[0]?.user?.value?.view_self_created_user
              );
            case 'Payout':
                return singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_list || singleRoleData?.[0]?.crypto?.value?.view_single_crypto_payout_list;
            case 'Payin':
                return singleRoleData?.[0]?.crypto?.value?.view_crypto_payin;
            case 'Role':
              return singleRoleData?.[0]?.role?.value?.view_role_list;
            case 'API Request Logs':
              return singleRoleData?.[0]?.api_request_logs?.value?.view_api_request_logs;
            case 'Audit Logs':
              return singleRoleData?.[0]?.audit_logs?.value?.view_user_audit_logs;
            case 'Blacklist':
              return singleRoleData?.[0]?.blacklist?.value?.view_blacklist_list;
            case 'Kyc Velocity':
              return singleRoleData?.[0]?.kyc_velocity?.value?.view_kyc_velocity;
            case 'Settings':
              return singleRoleData?.[0]?.settings?.value?.view_settings;
            case 'API Access':
              return singleRoleData?.[0]?.api?.value?.view_api_list;
            default:
              return true; // fallback to showing if no permission defined
          }
        };
        return (
          <div key={index}>
            {route.children ? (
              <div className="relative mb-3">
                <div
                  className="flex items-center px-5 cursor-pointer group"
                  onClick={() => toggleMenu(route.name)}
                >
                  <span 
                  className={`${
                    isOpen
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                  >
                    {route.icon ? route.icon : <DashIcon />}
                  </span>
                  <p
                      className={`leading-1 ml-2 flex ${
                        isOpen
                          ? "font-bold text-navy-700 dark:text-white"
                          : "font-medium text-gray-600"
                      }`}
                    >
                    {route.name}
                  </p>
                  <span className="ml-2">
                  {isOpen ? (
                    <AiFillCaretUp className="text-navy-700" /> // Up arrow when open
                  ) : (
                    <AiFillCaretDown  className="text-gray-600" /> // Down arrow when closed
                  )}
                  </span>
                </div>

                {/* Submenu */}
                {isOpen && (
                  <ul className="ml-7 mt-2 space-y-2">
                    {route.children.filter(hasChildPermission).map((child, childIndex) => (
                      <Link
                        key={childIndex}
                        to={child.layout + "/" + child.path}
                        className="block"
                        onClick={() => { window.scrollTo(0, 0); setActiveTab("single");}}
                      >
                        <li
                          className={`flex items-center px-5 py-1 ${
                            activeRoute(child.path)
                              ? "font-bold text-brand-500 dark:text-white border-r-indigo-500 border-r-[0.25rem] border-t-0 border-b-0 border-l-0"
                              : "text-gray-600"
                          }`}
                        >
                          {child.icon && <span className="mr-2">{child.icon}</span>}
                          <span>{child.name.replace(/\bKyc\b/, "KYC")}</span>
                        </li>
                        
                      </Link>
                    ))}
                  </ul>
                )}
              </div>
            ) : (
              // Regular route without submenu
              <Link key={index} to={route.layout + "/" + route.path} onClick={() => { window.scrollTo(0, 0); setOpenMenus({}); setActiveTab("single");}}>
                <div className="relative mb-3 flex hover:cursor-pointer">
                  <li className="my-[3px] flex cursor-pointer items-center px-5">
                    <span
                      className={`${
                        activeRoute(route.path)
                          ? "font-bold text-brand-500 dark:text-white"
                          : "font-medium text-gray-600"
                      }`}
                    >
                      {route.icon ? route.icon : <DashIcon />}
                    </span>
                    <p
                      className={`leading-1 ml-2 flex ${
                        activeRoute(route.path)
                          ? "font-bold text-navy-700 dark:text-white"
                          : "font-medium text-gray-600"
                      }`}
                    >
                      {route.name}
                    </p>
                  </li>
                  {activeRoute(route.path) ? (
                    <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                  ) : null}
                </div>
              </Link>
            )}
          </div>
        );
      }
      if (route.layout === "/auth" || route.layout === "/rtl") {
        if (!route?.isHidden) {
          return (
            <Link key={index} to={route.layout + "/" + route.path}>
              <div className="relative mb-3 flex hover:cursor-pointer">
                <li
                  className="my-[3px] flex cursor-pointer items-center px-8"
                  key={index}
                >
                  <span
                    className={`${activeRoute(route.path) === true
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                      }`}
                  >
                    {route.icon ? route.icon : <DashIcon />}{" "}
                  </span>
                  <p
                    className={`leading-1 ml-2 flex ${activeRoute(route.path) === true
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                      }`}
                  >
                    {route.name}
                  </p>
                </li>
                {activeRoute(route.path) ? (
                  <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                ) : null}
              </div>
            </Link>
          );
        }
      }
    });
  };
  // BRAND
  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
